// ============================================================
// GOOGLE FONTS
// ============================================================
export const GOOGLE_FONTS = `
@import url('https://fonts.googleapis.com/css2?family=Tiro+Devanagari+Hindi&family=Noto+Sans+Tamil:wght@400;600&family=Noto+Sans+Telugu:wght@400;600&family=Noto+Sans+Kannada:wght@400;600&family=Noto+Sans+Malayalam:wght@400;600&family=Noto+Sans+Bengali:wght@400;600&family=Noto+Sans+Gujarati:wght@400;600&family=Noto+Sans+Gurmukhi:wght@400;600&family=Noto+Sans+Odia:wght@400;600&family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&display=swap');
`;

// ============================================================
// 12 REGIONAL LANGUAGES
// ============================================================
export const LANGUAGES = [
  { code: "en", label: "English",   nativeLabel: "English",   flag: "🇬🇧", font: "'DM Sans', sans-serif" },
  { code: "hi", label: "Hindi",     nativeLabel: "हिंदी",      flag: "🇮🇳", font: "'Tiro Devanagari Hindi', serif" },
  { code: "mr", label: "Marathi",   nativeLabel: "मराठी",      flag: "🟠",  font: "'Tiro Devanagari Hindi', serif" },
  { code: "gu", label: "Gujarati",  nativeLabel: "ગુજરાતી",    flag: "🟦",  font: "'Noto Sans Gujarati', sans-serif" },
  { code: "pa", label: "Punjabi",   nativeLabel: "ਪੰਜਾਬੀ",     flag: "🟡",  font: "'Noto Sans Gurmukhi', sans-serif" },
  { code: "ta", label: "Tamil",     nativeLabel: "தமிழ்",      flag: "🟥",  font: "'Noto Sans Tamil', sans-serif" },
  { code: "te", label: "Telugu",    nativeLabel: "తెలుగు",     flag: "🟩",  font: "'Noto Sans Telugu', sans-serif" },
  { code: "kn", label: "Kannada",   nativeLabel: "ಕನ್ನಡ",      flag: "🟫",  font: "'Noto Sans Kannada', sans-serif" },
  { code: "ml", label: "Malayalam", nativeLabel: "മലയാളം",     flag: "🟪",  font: "'Noto Sans Malayalam', sans-serif" },
  { code: "bn", label: "Bengali",   nativeLabel: "বাংলা",      flag: "🔵",  font: "'Noto Sans Bengali', sans-serif" },
  { code: "or", label: "Odia",      nativeLabel: "ଓଡ଼ିଆ",      flag: "🟤",  font: "'Noto Sans Odia', sans-serif" },
  { code: "ur", label: "Urdu",      nativeLabel: "اردو",       flag: "⬛",  font: "'DM Sans', sans-serif" },
];

// ============================================================
// STATE → DISTRICT/DIVISION → MANDI
// ============================================================
export const STATES_DATA = {
  "Rajasthan": {
    districts: {
      "Jaipur":          ["Muhana Mandi", "Chomu Mandi", "Sambhar Mandi"],
      "Jodhpur":         ["Jodhpur Main Mandi", "Phalodi Mandi"],
      "Bikaner":         ["Bikaner Mandi", "Nokha Mandi"],
      "Kota":            ["Kota Krishi Mandi", "Bundi Mandi"],
      "Ajmer":           ["Ajmer Main Mandi", "Beawar Mandi"],
      "Sikar":           ["Sikar Mandi", "Fatehpur Mandi"],
      "Alwar":           ["Alwar Mandi", "Bhiwadi Mandi"],
      "Barmer":          ["Barmer Mandi", "Balotra Mandi"],
      "Sri Ganganagar":  ["Ganganagar Mandi", "Suratgarh Mandi"],
      "Hanumangarh":     ["Hanumangarh Mandi", "Sangaria Mandi"],
    },
  },
  "Uttar Pradesh": {
    districts: {
      "Lucknow":   ["Amausi Mandi", "Lucknow Main Mandi"],
      "Agra":      ["Agra Mandi", "Khandauli Mandi"],
      "Kanpur":    ["Kanpur Mandi", "Chakeri Mandi"],
      "Varanasi":  ["Varanasi Mandi", "Mughal Sarai Mandi"],
      "Meerut":    ["Meerut Mandi", "Partapur Mandi"],
      "Allahabad": ["Phaphamau Mandi", "Allahabad Main Mandi"],
      "Mathura":   ["Mathura Mandi", "Vrindavan Mandi"],
      "Unnao":     ["Unnao Mandi"],
      "Hapur":     ["Hapur Mandi"],
      "Jaunpur":   ["Jaunpur Mandi"],
    },
  },
  "Punjab": {
    districts: {
      "Amritsar":   ["Amritsar Main Mandi", "Tarn Taran Mandi"],
      "Ludhiana":   ["Ludhiana Grain Market", "Khanna Mandi"],
      "Patiala":    ["Patiala Mandi", "Rajpura Mandi"],
      "Jalandhar":  ["Jalandhar Mandi", "Nakodar Mandi"],
      "Bathinda":   ["Bathinda Mandi", "Mansa Mandi"],
      "Gurdaspur":  ["Gurdaspur Mandi", "Pathankot Mandi"],
      "Sangrur":    ["Sangrur Mandi", "Barnala Mandi"],
      "Hoshiarpur": ["Hoshiarpur Mandi"],
    },
  },
  "Madhya Pradesh": {
    districts: {
      "Bhopal":      ["Karond Mandi", "Bhopal Main Mandi"],
      "Indore":      ["Dewas Naka Mandi", "Indore Main Mandi"],
      "Ujjain":      ["Ujjain Mandi", "Nagda Mandi"],
      "Gwalior":     ["Gwalior Mandi"],
      "Jabalpur":    ["Jabalpur Mandi"],
      "Katni":       ["Katni Mandi"],
      "Sehore":      ["Sehore Mandi"],
      "Vidisha":     ["Vidisha Mandi"],
      "Morena":      ["Morena Mandi"],
      "Narsinghpur": ["Narsinghpur Mandi"],
    },
  },
  "Maharashtra": {
    districts: {
      "Pune":       ["Pune Market Yard", "Hadapsar Mandi"],
      "Nashik":     ["Nashik APMC", "Lasalgaon Mandi"],
      "Nagpur":     ["Nagpur Mandi", "Wardha Mandi"],
      "Aurangabad": ["Aurangabad Mandi", "Jalna Mandi"],
      "Solapur":    ["Solapur Mandi", "Pandharpur Mandi"],
      "Ahmednagar": ["Ahmednagar Mandi"],
      "Kolhapur":   ["Kolhapur Mandi"],
      "Latur":      ["Latur Mandi"],
      "Amravati":   ["Amravati Mandi"],
      "Yavatmal":   ["Yavatmal Mandi"],
    },
  },
  "Gujarat": {
    districts: {
      "Ahmedabad":   ["Ahmedabad APMC", "Aslali Mandi"],
      "Surat":       ["Surat APMC"],
      "Rajkot":      ["Rajkot Mandi", "Gondal Mandi"],
      "Vadodara":    ["Vadodara APMC"],
      "Gandhinagar": ["Gandhinagar Mandi"],
      "Anand":       ["Anand Mandi", "Petlad Mandi"],
      "Junagadh":    ["Junagadh Mandi"],
      "Amreli":      ["Amreli Mandi"],
    },
  },
  "Karnataka": {
    districts: {
      "Bengaluru Urban": ["KR Market APMC", "Yeshwanthpur APMC"],
      "Mysuru":          ["Mysuru APMC"],
      "Dharwad":         ["Dharwad APMC"],
      "Belagavi":        ["Belagavi APMC"],
      "Tumakuru":        ["Tumakuru APMC"],
      "Mandya":          ["Mandya APMC"],
      "Hassan":          ["Hassan APMC"],
      "Gadag":           ["Gadag APMC"],
    },
  },
  "Tamil Nadu": {
    districts: {
      "Chennai":     ["Koyambedu Market"],
      "Coimbatore":  ["Coimbatore APMC"],
      "Madurai":     ["Madurai APMC"],
      "Thiruvallur": ["Thiruvallur APMC"],
      "Erode":       ["Erode APMC"],
      "Tiruppur":    ["Tiruppur APMC"],
      "Dindigul":    ["Dindigul APMC"],
      "Salem":       ["Salem APMC"],
    },
  },
  "Andhra Pradesh": {
    districts: {
      "Visakhapatnam": ["Visakhapatnam APMC"],
      "Vijayawada":    ["Vijayawada APMC"],
      "Guntur":        ["Guntur APMC"],
      "Kurnool":       ["Kurnool APMC"],
      "Nellore":       ["Nellore APMC"],
    },
  },
  "West Bengal": {
    districts: {
      "Kolkata":     ["Koley Market"],
      "Howrah":      ["Howrah APMC"],
      "Hooghly":     ["Hooghly APMC"],
      "Bardhaman":   ["Bardhaman APMC"],
      "Murshidabad": ["Murshidabad APMC"],
    },
  },
};

// ============================================================
// COMMODITIES — all 12 languages
// ============================================================
export const COMMODITIES = [
  { key: "wheat",     en: "Wheat",      hi: "गेहूं",    mr: "गहू",      gu: "ઘઉં",    pa: "ਕਣਕ",    ta: "கோதுமை",         te: "గోధుమ",        kn: "ಗೋಧಿ",       ml: "ഗോതമ്പ്",        bn: "গম",       or: "ଗହମ",    ur: "گندم",    base: 2150,  v: 200  },
  { key: "rice",      en: "Rice",       hi: "चावल",     mr: "तांदूळ",   gu: "ચોખા",   pa: "ਚਾਵਲ",   ta: "அரிசி",          te: "వరి",          kn: "ಅಕ್ಕಿ",      ml: "അരി",            bn: "চাল",      or: "ଚାଉଳ",  ur: "چاول",   base: 3200,  v: 300  },
  { key: "onion",     en: "Onion",      hi: "प्याज",    mr: "कांदा",    gu: "ડુંગળી",  pa: "ਪਿਆਜ਼",  ta: "வெங்காயம்",     te: "ఉల్లిపాయ",    kn: "ಈರುಳ್ಳಿ",   ml: "ഉള്ളി",          bn: "পেঁয়াজ",   or: "ପିଆଜ",  ur: "پیاز",   base: 1800,  v: 800  },
  { key: "tomato",    en: "Tomato",     hi: "टमाटर",    mr: "टोमॅटो",   gu: "ટામેટા", pa: "ਟਮਾਟਰ",  ta: "தக்காளி",       te: "టమాటా",       kn: "ಟೊಮೆಟೊ",   ml: "തക്കാളി",        bn: "টমেটো",    or: "ଟମାଟୋ", ur: "ٹماٹر",  base: 2500,  v: 1500 },
  { key: "potato",    en: "Potato",     hi: "आलू",      mr: "बटाटा",    gu: "બટાટા",  pa: "ਆਲੂ",    ta: "உருளைக்கிழங்கு", te: "బంగాళాదుంప", kn: "ಆಲೂಗೆಡ್ಡೆ", ml: "ഉരുളക്കിഴങ്ങ്", bn: "আলু",      or: "ଆଳୁ",   ur: "آلو",    base: 1200,  v: 400  },
  { key: "mustard",   en: "Mustard",    hi: "सरसों",    mr: "मोहरी",    gu: "રાઈ",    pa: "ਸਰ੍ਹੋਂ",  ta: "கடுகு",          te: "ఆవాలు",       kn: "ಸಾಸಿವೆ",    ml: "കടുക്",          bn: "সরিষা",    or: "ସୋରିଷ", ur: "سرسوں",  base: 5200,  v: 400  },
  { key: "soybean",   en: "Soybean",    hi: "सोयाबीन",  mr: "सोयाबीन",  gu: "સોયાબીન",pa: "ਸੋਇਆਬੀਨ",ta: "சோயாபீன்",      te: "సోయాబీన్",   kn: "ಸೋಯಾಬೀನ್", ml: "സോയാബീൻ",       bn: "সয়াবিন",   or: "ସୋୟାବିନ",ur: "سویابین", base: 4300,  v: 500  },
  { key: "maize",     en: "Maize",      hi: "मक्का",    mr: "मका",      gu: "મકાઈ",   pa: "ਮੱਕੀ",   ta: "மக்காச்சோளம்",  te: "మొక్కజొన్న", kn: "ಜೋಳ",       ml: "ചോളം",           bn: "ভুট্টা",   or: "ମକା",   ur: "مکئی",   base: 1900,  v: 250  },
  { key: "garlic",    en: "Garlic",     hi: "लहसुन",    mr: "लसूण",     gu: "લસણ",    pa: "ਲਸਣ",    ta: "பூண்டு",         te: "వెల్లుల్లి", kn: "ಬೆಳ್ಳುಳ್ಳಿ", ml: "വെളുത്തുള്ളി",  bn: "রসুন",     or: "ରସୁଣ",  ur: "لہسن",   base: 6500,  v: 2000 },
  { key: "cotton",    en: "Cotton",     hi: "कपास",     mr: "कापूस",    gu: "કપાસ",   pa: "ਕਪਾਹ",   ta: "பருத்தி",        te: "పత్తి",      kn: "ಹತ್ತಿ",     ml: "പഞ്ഞി",          bn: "তুলা",     or: "କପା",   ur: "کپاس",   base: 6200,  v: 600  },
  { key: "groundnut", en: "Groundnut",  hi: "मूंगफली",  mr: "शेंगदाणे", gu: "મગફળી",  pa: "ਮੂੰਗਫਲੀ", ta: "வேர்க்கடலை",   te: "వేరుశనగ",   kn: "ಕಡಲೆಕಾಯಿ", ml: "നിലക്കടല",       bn: "চিনাবাদাম", or: "ଚିନାବାଦାମ",ur: "مونگ پھلی",base: 5800, v: 700  },
  { key: "chilli",    en: "Chilli",     hi: "मिर्च",    mr: "मिरची",    gu: "મરચું",   pa: "ਮਿਰਚ",   ta: "மிளகாய்",       te: "మిరపకాయ",   kn: "ಮೆಣಸಿನಕಾಯಿ",ml: "മുളക്",          bn: "মরিচ",     or: "ମରିଚ",  ur: "مرچ",    base: 12000, v: 4000 },
  { key: "turmeric",  en: "Turmeric",   hi: "हल्दी",    mr: "हळद",      gu: "હળદર",   pa: "ਹਲਦੀ",   ta: "மஞ்சள்",        te: "పసుపు",      kn: "ಅರಿಶಿನ",    ml: "മഞ്ഞൾ",          bn: "হলুদ",     or: "ହଳଦୀ",  ur: "ہلدی",   base: 8000,  v: 2000 },
  { key: "sugarcane", en: "Sugarcane",  hi: "गन्ना",    mr: "ऊस",       gu: "શેરડી",  pa: "ਗੰਨਾ",   ta: "கரும்பு",       te: "చెరకు",      kn: "ಕಬ್ಬು",     ml: "കരിമ്പ്",        bn: "আখ",       or: "ଆଖୁ",   ur: "گنا",    base: 350,   v: 80   },
];


// ============================================================
// COMMODITIES — LANG FEATURE
// ============================================================
export const FEATURE_CARDS = {
  icon: ["⚡", "📲", "🌐", "🗺️"],
  titles: {
    en: ["Live Rates",        "WhatsApp at 7AM",                   "12 Languages",                      "Division/District"],
    hi: ["लाइव भाव",          "WhatsApp 7 बजे",                    "12 भाषाएं",                         "विभाग/जिला"],
    mr: ["लाइव भाव",          "WhatsApp सकाळी ७ वाजता",            "१२ भाषा",                           "विभाग/जिल्हा"],
    gu: ["લાઇવ ભાવ",          "WhatsApp સવારે ૭ વાગ્યે",           "૧૨ ભાષાઓ",                          "વિભાગ/જિલ્લો"],
    pa: ["ਲਾਈਵ ਭਾਅ",          "WhatsApp ਸਵੇਰੇ ੭ ਵਜੇ",             "੧੨ ਭਾਸ਼ਾਵਾਂ",                       "ਵਿਭਾਗ/ਜ਼ਿਲ੍ਹਾ"],
    ta: ["நேரடி விலைகள்",     "WhatsApp காலை 7 மணிக்கு",          "12 மொழிகள்",                        "பிரிவு/மாவட்டம்"],
    te: ["లైవ్ ధరలు",         "WhatsApp ఉదయం 7 గంటలకు",          "12 భాషలు",                          "విభాగం/జిల్లా"],
    kn: ["ಲೈವ್ ದರ",           "WhatsApp ಬೆಳಿಗ್ಗೆ 7 ಗಂಟೆ",        "12 ಭಾಷೆಗಳು",                        "ವಿಭಾಗ/ಜಿಲ್ಲೆ"],
    ml: ["തത്സമയ വില",        "WhatsApp രാവിലെ 7 മണിക്ക്",       "12 ഭാഷകൾ",                          "ഡിവിഷൻ/ജില്ല"],
    bn: ["লাইভ দর",           "WhatsApp সকাল ৭টায়",               "১২ ভাষা",                           "বিভাগ/জেলা"],
    or: ["ଲାଇଭ ଭାବ",          "WhatsApp ସକାଳ ୭ ଟାରେ",             "୧୨ ଭାଷା",                           "ବିଭାଗ/ଜିଲ୍ଲା"],
    ur: ["لائیو بھاؤ",         "WhatsApp صبح 7 بجے",               "12 زبانیں",                         "ڈویژن/ضلع"],
  },
  descs: {
    en: ["Daily prices from AGMARKNET/data.gov.in",         "Instant acknowledgement + daily mandi bhav",          "Hindi, Tamil, Telugu, Marathi & 8 more",             "Find your mandi by Division or District"],
    hi: ["AGMARKNET से दैनिक सरकारी भाव",                   "पंजीकरण पर तुरंत WhatsApp + रोज़ 7 बजे",             "हिंदी, तमिल, तेलुगु, मराठी और 8 और",               "विभाग या जिले से मंडी खोजें"],
    mr: ["AGMARKNET कडून दैनंदिन सरकारी भाव",              "नोंदणीवर तात्काळ WhatsApp + रोज सकाळी ७ वाजता",     "हिंदी, तमिळ, तेलुगु, मराठी आणि ८ इतर",             "विभाग किंवा जिल्ह्यातून मंडी शोधा"],
    gu: ["AGMARKNET પરથી દૈનિક સરકારી ભાવ",                "નોંધણી પર તરત WhatsApp + રોજ સવારે ૭ વાગ્યે",       "હિન્દી, તમિળ, તેલુગુ, મરાઠી અને બીજી ૮",           "વિભાગ અથવા જિલ્લા દ્વારા મંડી શોધો"],
    pa: ["AGMARKNET ਤੋਂ ਰੋਜ਼ਾਨਾ ਸਰਕਾਰੀ ਭਾਅ",              "ਰਜਿਸਟ੍ਰੇਸ਼ਨ 'ਤੇ ਤੁਰੰਤ WhatsApp + ਰੋਜ਼ ੭ ਵਜੇ",       "ਹਿੰਦੀ, ਤਮਿਲ, ਤੇਲੁਗੂ, ਮਰਾਠੀ ਅਤੇ ੮ ਹੋਰ",            "ਵਿਭਾਗ ਜਾਂ ਜ਼ਿਲ੍ਹੇ ਤੋਂ ਮੰਡੀ ਲੱਭੋ"],
    ta: ["AGMARKNET-இல் இருந்து தினசரி அரசு விலைகள்",     "பதிவின் போது உடனடி WhatsApp + தினமும் 7 மணிக்கு",   "இந்தி, தமிழ், தெலுங்கு, மராத்தி மற்றும் மேலும் 8", "பிரிவு அல்லது மாவட்டத்தின் மூலம் மண்டியை தேடுங்கள்"],
    te: ["AGMARKNET నుండి రోజువారీ ప్రభుత్వ ధరలు",        "నమోదుపై వెంటనే WhatsApp + రోజూ 7 గంటలకు",          "హిందీ, తమిళ్, తెలుగు, మరాఠీ మరియు మరో 8",         "విభాగం లేదా జిల్లా ద్వారా మండీ వెతకండి"],
    kn: ["AGMARKNET ನಿಂದ ದೈನಂದಿನ ಸರ್ಕಾರಿ ದರ",            "ನೋಂದಣಿಯಲ್ಲಿ ತಕ್ಷಣ WhatsApp + ದಿನವೂ 7 ಗಂಟೆಗೆ",      "ಹಿಂದಿ, ತಮಿಳು, ತೆಲುಗು, ಮರಾಠಿ ಮತ್ತು ಇನ್ನೂ 8",       "ವಿಭಾಗ ಅಥವಾ ಜಿಲ್ಲೆಯಿಂದ ಮಂಡಿ ಹುಡುಕಿ"],
    ml: ["AGMARKNET-ൽ നിന്നുള്ള ദൈനംദിന സർക്കാർ വില",    "രജിസ്ട്രേഷനിൽ ഉടനടി WhatsApp + ദിവസവും 7 മണിക്ക്","ഹിന്ദി, തമിഴ്, തെലുഗു, മറാത്തി, മറ്റ് 8 ഭാഷകൾ",   "ഡിവിഷൻ അല്ലെങ്കിൽ ജില്ല അനുസരിച്ച് മണ്ടി കണ്ടെത്തുക"],
    bn: ["AGMARKNET থেকে দৈনিক সরকারি দর",                 "নিবন্ধনে তাৎক্ষণিক WhatsApp + প্রতিদিন ৭টায়",      "হিন্দি, তামিল, তেলুগু, মারাঠি এবং আরও ৮",          "বিভাগ বা জেলা দিয়ে মান্দি খুঁজুন"],
    or: ["AGMARKNET ରୁ ଦୈନିକ ସରକାରୀ ଭାବ",                 "ପଞ୍ଜୀକରଣ ପରେ ତୁରନ୍ତ WhatsApp + ରୋଜ ୭ ଟାରେ",       "ହିନ୍ଦୀ, ତାମିଲ, ତେଲୁଗୁ, ମରାଠୀ ଏବଂ ଆଉ ୮ ଟି",        "ବିଭାଗ ବା ଜିଲ୍ଲା ଅନୁଯାୟୀ ମଣ୍ଡି ଖୋଜନ୍ତୁ"],
    ur: ["AGMARKNET سے روزانہ سرکاری بھاؤ",                 "رجسٹریشن پر فوری WhatsApp + روزانہ 7 بجے",           "ہندی، تمل، تیلگو، مراٹھی اور 8 مزید",               "ڈویژن یا ضلع سے منڈی تلاش کریں"],
  },
};

// ── Section heading translations ─────────────────────────────
export const WHY_HEADING = {
  en: "Why MandiMitra?",
  hi: "मंडी मित्र क्यों?",
  mr: "मंडी मित्र का?",
  gu: "મંડી મિત્ર શા માટે?",
  pa: "ਮੰਡੀ ਮਿੱਤਰ ਕਿਉਂ?",
  ta: "மண்டி மித்ரா ஏன்?",
  te: "మండీ మిత్ర ఎందుకు?",
  kn: "ಮಂಡಿ ಮಿತ್ರ ಏಕೆ?",
  ml: "മണ്ടി മിത്ര എന്തുകൊണ്ട്?",
  bn: "মান্দি মিত্র কেন?",
  or: "ମଣ୍ଡି ମିତ୍ର କାହିଁକି?",
  ur: "منڈی مترا کیوں؟",
};

export const WHY_SUBTITLE = {
  en: "Real-time market rates for every farmer, in every language",
  hi: "हर किसान के लिए, हर भाषा में लाइव मंडी भाव",
  mr: "प्रत्येक शेतकऱ्यासाठी, प्रत्येक भाषेत लाइव मंडी भाव",
  gu: "દરેક ખેડૂત માટે, દરેક ભાષામાં લાઇવ મંડી ભાવ",
  pa: "ਹਰ ਕਿਸਾਨ ਲਈ, ਹਰ ਭਾਸ਼ਾ ਵਿੱਚ ਲਾਈਵ ਮੰਡੀ ਭਾਅ",
  ta: "ஒவ்வொரு விவசாயிக்கும், ஒவ்வொரு மொழியிலும் நேரடி மண்டி விலைகள்",
  te: "ప్రతి రైతుకు, ప్రతి భాషలో లైవ్ మండీ ధరలు",
  kn: "ಪ್ರತಿ ರೈತನಿಗೆ, ಪ್ರತಿ ಭಾಷೆಯಲ್ಲಿ ಲೈವ್ ಮಂಡಿ ದರ",
  ml: "എല്ലാ കർഷകർക്കും, എല്ലാ ഭാഷകളിലും തത്സമയ മണ്ടി വില",
  bn: "প্রতিটি কৃষকের জন্য, প্রতিটি ভাষায় লাইভ মান্দি দর",
  or: "ପ୍ରତ୍ୟେକ କୃଷକଙ୍କ ପାଇଁ, ପ୍ରତ୍ୟେକ ଭାଷାରେ ଲାଇଭ ମଣ୍ଡି ଭାବ",
  ur: "ہر کسان کے لیے، ہر زبان میں لائیو منڈی بھاؤ",
};

// ── WhatsApp CTA subtitle translations ───────────────────────
export const WA_SUBTITLE = {
  en: "Register now and get an instant WhatsApp confirmation!",
  hi: "अभी पंजीकरण करें और तुरंत WhatsApp पर सन्देश पाएं!",
  mr: "आत्ताच नोंदणी करा आणि तात्काळ WhatsApp वर संदेश मिळवा!",
  gu: "અત્યારે નોંધણી કરો અને તરત WhatsApp પર સંદેશ મેળવો!",
  pa: "ਹੁਣੇ ਰਜਿਸਟਰ ਕਰੋ ਅਤੇ ਤੁਰੰਤ WhatsApp 'ਤੇ ਸੁਨੇਹਾ ਪਾਓ!",
  ta: "இப்போதே பதிவு செய்து உடனடியாக WhatsApp-ல் செய்தி பெறுங்கள்!",
  te: "ఇప్పుడే నమోదు చేసుకోండి మరియు వెంటనే WhatsApp లో సందేశం పొందండి!",
  kn: "ಈಗಲೇ ನೋಂದಣಿ ಮಾಡಿ ಮತ್ತು ತಕ್ಷಣ WhatsApp ನಲ್ಲಿ ಸಂದೇಶ ಪಡೆಯಿರಿ!",
  ml: "ഇപ്പോൾ രജിസ്റ്റർ ചെയ്ത് ഉടനടി WhatsApp-ൽ സന്ദേശം നേടൂ!",
  bn: "এখনই নিবন্ধন করুন এবং তাৎক্ষণিক WhatsApp বার্তা পান!",
  or: "ଏବେ ପଞ୍ଜୀକରଣ କରନ୍ତୁ ଏବଂ ତୁରନ୍ତ WhatsApp ରେ ସନ୍ଦେଶ ପାଆନ୍ତୁ!",
  ur: "ابھی رجسٹر کریں اور فوری طور پر WhatsApp پر پیغام پائیں!",
};
